export enum Login {
    LOGIN_SUCCESS = 'login_success',
    LOGIN_FAILED = 'login_failed',
    LOGIN_NOT_AUTHORIZED = 'login_not_authorized',
    LOGIN_NOT_VALID = 'login_not_valid',
    LOG_OUT_FAILED = 'logout_failed',
    LOG_OUT_SUCCESS = 'logout_success',
}
